import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useTranslation } from 'react-i18next';

import InputBox from '../../../components/Input/InputBox';
import BaseButton from '../../../components/common/BaseButton';

import api from '../../../utils/api';
import { formikErrorInput, formikErrorMessage } from '../../../utils/helper';

const FormCreateNewPassword = () => {
  const { search } = useLocation();
  const history = useHistory();
  const { t } = useTranslation();

  const query = new URLSearchParams(search);

  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      password: '',
      password_confirmation: '',
    },

    validationSchema: Yup.object({
      password: Yup.string()
        .required(t('reset_password.required_password'))
        .min(8, t('sign_up.lenght_password')),

      password_confirmation: Yup.string()
        .oneOf(
          [Yup.ref('password'), null],
          t('reset_password.not_same_passwords')
        )
        .required(t('reset_password.required_password_confirem'))
        .min(8, t('sign_up.lenght_password')),
    }),

    onSubmit: (values) => {
      createNewPassword(values);
    },
  });

  const createNewPassword = async (values) => {
    let token = query.get('token');
    let email = query.get('email');

    setIsLoading(true);
    const resetPasswordReq = await api.call({
      name: 'resetPassword',
      data: {
        ...values,
        token,
        email,
      },
    });
    if (resetPasswordReq.status === 200) {
      history.push('/login');
    }
    setIsLoading(false);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <InputBox
        placeholder={t('reset_password.input_password_placeholder')}
        type="password"
        password
        checkStrong
        ErrorInput={formikErrorInput(formik, 'password')}
        errorMassage={formikErrorMessage(formik, 'password')}
        value={formik.values.password}
        labelText="Password"
        name="password"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      <InputBox
        placeholder={t('reset_password.input_password_confirm_placeholder')}
        type="password"
        password
        ErrorInput={formikErrorInput(formik, 'password_confirmation')}
        errorMassage={formikErrorMessage(formik, 'password_confirmation')}
        value={formik.values.password_confirmation}
        labelText="Confirmation Password"
        name="password_confirmation"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
      <BaseButton
        disabled={isLoading}
        loading={isLoading}
        type="submit"
        sx={{ width: '100%', mt: 2 }}
      >
        Reset Password
      </BaseButton>
    </form>
  );
};
export default FormCreateNewPassword;
